var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 106,
    viewBox: "0 0 127 106",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M122.099 54.9C122.099 69.1 116.299 81.9 106.999 91.1C97.899 100.2 85.299 105.7 71.399 105.7C57.599 105.7 44.999 100.1 35.799 91.1C26.499 81.9 20.699 69.1 20.699 54.9C20.699 26.8 43.399 4.09998 71.399 4.09998C99.399 4.09998 122.099 26.9 122.099 54.9Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M117.7 21.6C119.964 21.6 121.8 19.76 121.8 17.5C121.8 15.23 119.964 13.4 117.7 13.4C115.435 13.4 113.6 15.23 113.6 17.5C113.6 19.76 115.435 21.6 117.7 21.6Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M123.7 5.6C125.246 5.6 126.5 4.34 126.5 2.8C126.5 1.25 125.246 0 123.7 0C122.153 0 120.9 1.25 120.9 2.8C120.9 4.34 122.153 5.6 123.7 5.6Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M22.3 21.5C23.846 21.5 25.1 20.24 25.1 18.7C25.1 17.15 23.846 15.9 22.3 15.9C20.753 15.9 19.5 17.15 19.5 18.7C19.5 20.24 20.753 21.5 22.3 21.5Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M5.2 75.5C8.071 75.5 10.4 73.17 10.4 70.3C10.4 67.43 8.071 65.1 5.2 65.1C2.328 65.1 0 67.43 0 70.3C0 73.17 2.328 75.5 5.2 75.5Z",
    fill: "#EAEEF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M107 28.3V91.1C97.9 100.2 85.3 105.7 71.4 105.7C57.6 105.7 45 100.1 35.8 91.1V28.3H107Z",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M78.789 39.5L58 60.29L62.738 65.02L83.527 44.23L78.789 39.5Z",
    fill: "#EE7070"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M78.789 65.02L58 44.23L62.738 39.5L83.527 60.29L78.789 65.02Z",
    fill: "#EE7070"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M89.599 73.6H53.199V78.2H89.599V73.6Z",
    fill: "#D5DAE5"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M89.599 83.7H53.199V88.3H89.599V83.7Z",
    fill: "#D5DAE5"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M80.7 93.9H62.1V98.5H80.7V93.9Z",
    fill: "#D5DAE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorPlaceholder);
export default __webpack_public_path__ + "static/media/error_placeholder.1ce2791e001c3d1d098732295b3cd621.svg";
export { ForwardRef as ReactComponent };